import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed !important',
    zIndex: 999,
    height: '2em !important',
    width: '2em !important',
    overflow: 'show !important',
    margin: 'auto !important',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  loaderContainer: {
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    alignContent: 'center !important',
    position: 'relative !important',
  },
  progress: {
    position: 'absolute !important',
  },
}));
